import { Component, Input } from '@angular/core';
import { ChatMessage } from '../model/search-message-dto';
import { TableModule } from 'primeng/table';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentBase } from '../../../../../common/component-base';
import { LinkifyPipe } from '../../../../../common/pipes/linkify.pipe';

import { Constants } from '../../../../../common/helper/Constants';

@Component({
  selector: 'gate-search-license-result',
  standalone: true,
  imports: [TableModule, TranslatePipe, LinkifyPipe],
  templateUrl: './search-license-result.component.html',
  styleUrl: './search-license-result.component.scss'
})
export class SearchLicenseResultComponent  extends ComponentBase {
  @Input() public searchMessage!: ChatMessage;
  constructor() {
    super();
  }

  openLicense(microsoftTenantID: string) {
    var url: string = "/"+Constants.routes.license()+`?microsoftTenantID=${microsoftTenantID}`;
      console.log('openLicense', url);
    if(url)
      this.navigateToNewTab(url);
  }
}
